import _ from 'lodash';
import { axiosInstance } from '../helpers/axios';
import { userService } from './user.service';

export const templateService = {
  create,
  findAll,
  getById,
  getResources,
  update,
  uploadTutorialVideo,
  deleteTutorialVideo,
};

function create(template) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: template,
  };

  return axiosInstance
    .post(`/templates`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .then(response => {
      return response;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function findAll(query) {
  return axiosInstance
    .get(`/templates`, { params: query })
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function getById(id) {
  return axiosInstance.get(`/templates/${id}`).then(handleResponse);
}

function getResources(id) {
  return axiosInstance.get(`/templates/${id}/resources`).then(handleResponse);
}

function update({ id, ...template }) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: template,
  };

  return axiosInstance
    .put(`/templates/${id}`, requestOptions.body, requestOptions.headers)
    .then(handleResponse);
}

function uploadTutorialVideo(id, file) {
  const formData = new FormData();
  formData.append('file', file);
  return axiosInstance
    .post(`/templates/${id}/tutorial-video`, formData)
    .then(handleResponse);
}

function deleteTutorialVideo(id) {
  return axiosInstance
    .delete(`/templates/${id}/tutorial-video`)
    .then(handleResponse);
}

const handleResponse = response => {
  const data = response.data;
  if (!_.includes([200, 201, 204], response.status)) {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      userService.logout().then(() => window.location.reload(true));
    }

    const error = (data && data.message) || response.statusText;

    // eslint-disable-next-line no-throw-literal
    throw { status: response.status, error };
  }

  return data;
};
